import { useContext } from 'react';
import { AIPopupContext } from '../providers/AIPopupProvider';

const useAiPopup = () => useContext(AIPopupContext);

export default useAiPopup;
